module.exports = __webpack_public_path__ + "img/royal-antwerp.ec6257a7.png";